import dayjs from "dayjs";
import { fallbackImg } from "./constants";
const day = dayjs();

export const checkIfImageExists = (url, callback) => {
  if (!url) return false;
  const img = new Image();
  img.src = url;

  if (img.complete) callback(true);
  else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
};
export const arrayFrom = (count = 1) => Array(+count).fill(0);

export function currencyFormat(num = 0) {
  return parseFloat(num)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function numberFormat(num = "0") {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const limitedText = (text = "", lng) => {
  if (!text) return "";
  const strText = text.toString().trim();
  // console.log('limitedText  strText', strText);
  if (!lng || strText.length <= lng) return strText;
  return strText.substring(0, lng) + "...";
};

export const camelToNrm = (text) => {
  return text.replace(/[A-Z]/g, (t) => " " + t.toLowerCase());
};

export const getPercentage = (num1, num2) => {
  const percent = Math.floor(100 * (num2 / num1));
  if (percent > 100) return 100;
  return percent;
};

export const slugify = (str = "") =>
  str
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\u0621-\u064A0-9-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

export const onErrorImg = ({ target }, fallback) => {
  target.onerror = null;
  target.src = fallback ? fallback : fallbackImg;
};

export const dateFormat = (date, format = "YYYY-MM-DD") => {
  return dayjs(date).format(format);
};

export const disabledDateBeforeToday = (current) => {
  // Can not select days before today and today
  return current && current < dayjs().endOf("day");
};

export const checkStringInLanguage = (str, lng) => {
  if (lng === "ar") {
    // Allows Arabic letters, numbers, and spaces
    return new RegExp("^[\u0621-\u064A0-9 ]+$").test(str);
  }
  if (lng === "en") {
    // Allows English letters (both uppercase and lowercase), numbers, and spaces
    return new RegExp(/^[a-zA-Z0-9\s]*$/).test(str);
  }
};

export const getTimeFormat = (timeString) => {
  const formattedTime = day
    .set("hour", timeString.split(":")[0])
    .set("minute", timeString.split(":")[1])
    .format("h:mm");
  return formattedTime;
};

function hexToRgb(hex) {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
}
export function getLuminance(hex) {
  const rgb = hexToRgb(hex);
  const luminance = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
  return luminance;
}
